import { TranslationService } from '@/utils/services/TranslationService';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { EngagementConfig } from '@/lib/analytics/pages/engagement';
import { ANALYZE_ENGAGEMENT } from '@/lib/routes/privateRoutes';

import { LayoutAnalytics } from '@/components/layouts/wrappers/LayoutAnalytics';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';

const Engagement = () => {
    const { t: tCommons } = useTranslation('commons');

    return (
        <WrapperSwitchLayout>
            <LayoutAnalytics profileConfig={EngagementConfig} title={tCommons('menu.engagement')} />
        </WrapperSwitchLayout>
    );
};

export const getStaticProps =
    TranslationService.getTranslationMessagesFromRoute(ANALYZE_ENGAGEMENT);

export default Engagement;
